<template>
  <div class="page">
    <div v-if="listData.length === 0">
      <img
        src="../../assets/list-none.png"
        alt=""
        width="200"
        class="table-empty"
      />
      <div>空荡荡的～暂无数据！</div>
    </div>
    <div v-else>
      <div v-for="item in listData" :key="item.id">
        <div v-if="item.bills.length > 0">
          <el-table
            :data="item.bills"
            style="width: 100%; margin-top: 20px"
            @selection-change="
              selections => {
                handleSelectionChange(selections, item.bills);
              }
            "
          >
            <el-table-column type="selection" width="45" v-if="canOption">
            </el-table-column>
            <el-table-column
              prop="pricingName"
              :label="item.areaName + item.houseName"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column label="费用详情" align="center" min-width="160">
              <template slot-scope="scope">
                <div style="width: 100%">
                  <div class="div-2">
                    <div class="div-2-title">开始时间:</div>
                    <div class="div-2-content">
                      {{ long2day(scope.row.billStart * 1000) }}
                    </div>
                  </div>
                  <div class="div-2">
                    <div class="div-2-title">结束时间:</div>
                    <div class="div-2-content">
                      {{ long2day(scope.row.billEnd * 1000) }}
                    </div>
                  </div>
                  <div class="div-2">
                    <div class="div-2-title">总金额(元):</div>
                    <div class="div-2-content">
                      {{ scope.row.totalAmount / 100 }}
                    </div>
                  </div>
                  <div class="div-2">
                    <div class="div-2-title">备注:</div>
                    <div class="div-2-content">{{ scope.row.comment }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-button
      :loading="isLoading"
      round
      class="footer"
      v-if="canOption"
      @click="showQR"
      size="medium"
      type="primary"
      style="margin-top: 30px; width: 80%"
      :disabled="billIdList.length === 0"
      >{{ isLoading ? "支付中..." : "确定支付" }}</el-button
    >
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import wx from "weixin-js-sdk";

export default {
  name: "home",

  data() {
    return {
      listData: [],
      billIdList: new Set(),
      state: "全部",
      moneyStr: "",
      canOption: true,
      isLoading: false
    };
  },

  created() {
    Utils.userInfo.client = this.$route.query.client;
    let state = this.$route.query.state === "1";

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", this.$route.query.client || "");

    if (state) {
      this.state = "未支付";
      this.canOption = true;
      document.title = "待缴账单";
    } else {
      this.state = "已支付";
      this.canOption = false;
      document.title = "缴费记录";
    }
    this.query();
  },

  methods: {
    handleSelectionChange(val, item) {
      let _vue = this;
      item.forEach(listItem => {
        _vue.billIdList.delete(listItem.id);
      });
      val.forEach(listItem => {
        _vue.billIdList.add(listItem.id);
      });
    },

    long2day(time) {
      return Utils.long2day(time);
    },

    showQR() {
      if (this.isLoading === true) {
        return;
      }
      let url = axios.defaults.baseURL + "bills/pay";
      url = url.replace("org", "users");
      url = url.replace("10241", "10242");

      this.isLoading = true;

      axios({
        method: "post",
        url: url,
        data: {
          billIDs: Array.from(this.billIdList)
        }
      })
        .then(value => {
          if (value.data.code === 0) {
            let data = value.data.data;
            // 微信小程序
            wx.miniProgram.getEnv(function() {
              wx.miniProgram.navigateTo({
                url:
                  "/pages/bills/pay?" +
                  "orderID=" +
                  data.orderID +
                  "&prepayID=" +
                  data.prepayID +
                  "&expiredAt=" +
                  data.expiredAt
              });
            });
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    //列表查询
    query() {
      let url = axios.defaults.baseURL + "bills/query";
      url = url.replace("org", "users");
      url = url.replace("10241", "10242");

      let data = {
        houseNameRegex: this.houseNameRegex,
        state: this.state,
        pricingName: this.pricingName,
        pageSize: 100,
        pageIdx: 0
      };

      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: url,
        data: data
      })
        .then(value => {
          this.listData = [];
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.house = item.areaName + item.houseName;
              item.billStart = Utils.long2day(item.billStart * 1000);
              item.billEnd = Utils.long2day(item.billEnd * 1000);
              item.paidTime = Utils.long2day(item.paidTime * 1000);
              item.paidAmountStr = item.paidAmount / 100;
              item.totalAmountStr = item.totalAmount / 100;
              this.listData.push(item);
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.table__header {
  background: #409eff;
}
.el-table__header {
  background: #409eff !important;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.header-title {
  text-align: end;
  width: 150px;
  margin-right: 15px;
}
.div-2-title {
  font-size: 12px;
}
.div-2-content {
  font-size: 12px;
}
.footer {
  position: sticky;
  bottom: 10px;
}
</style>
